import { Box } from '@mui/material';
import { FC } from 'react';
import { FormLayoutContainer } from 'components/FormLayout';
import { dashboardFiltersForm } from 'modules/maya/components/DashboardFilters/DashboardFilters.style';
import { DashboardFiltersPropsType } from 'modules/maya/components/DashboardFilters/DashboardFilters.types';
import FormContainer from 'modules/maya/components/FormContainer/FormContainer';
import DateRangePicker from 'yoda-ui/Form/DateRangePicker';
import SelectYoda from 'yoda-ui/Form/SelectYoda';
import MultiSelectYoda from 'yoda-ui/Form/SelectYoda/MultiSelectYoda';
import { YodaJustifyContent } from 'yoda-ui/yodaTheme';

const DashboardFilters: FC<DashboardFiltersPropsType> = ({
  dashboardFiltersConfig,
  providerFields,
  handleChangeTA,
  handleChangeProduct,
  submitButtonConfig,
  resetButtonConfig,
}) => {
  return (
    <FormContainer providerFields={ providerFields } cancelButtonConfig={ resetButtonConfig } submitButtonConfig={ submitButtonConfig } >
      <FormLayoutContainer justifyContent={ YodaJustifyContent.spaceBetween } sx={ dashboardFiltersForm } >
        <Box>
          <MultiSelectYoda { ...dashboardFiltersConfig.countries } />
        </Box>
        <Box>
          <SelectYoda { ...dashboardFiltersConfig.therapeuticArea } onChange={ handleChangeTA } />
        </Box>
        <Box>
          <MultiSelectYoda { ...dashboardFiltersConfig.product } onChange={ handleChangeProduct } />
        </Box>
        <Box>
          <MultiSelectYoda { ...dashboardFiltersConfig.cepFunction } />
        </Box>
        <Box>
          <MultiSelectYoda { ...dashboardFiltersConfig.cepStatus } />
        </Box>
      </FormLayoutContainer>

      <Box>
        <DateRangePicker { ...dashboardFiltersConfig.date } />
      </Box>
    </FormContainer>
  );
};

export default DashboardFilters;
